const HIDDEN_UNITS = new Set(['', '1', 'category']);

export const formatAttributeLabel = (name: string, unit?: string | null): string => {
  const normalizedUnit = (unit ?? '').trim();
  if (HIDDEN_UNITS.has(normalizedUnit)) {
    return name;
  }
  return `${name} (${normalizedUnit})`;
};
